

import React, { Component } from 'react';
import _omit from 'lodash.omit';
import _memoize from 'lodash.memoize';
import { getStringValueFromGenericInput } from '@shootsta/get-value-from-generic-input';
import { Text } from '../../../../../../ui-kit';
import SettingSection from './SettingSection';
import PasswordProtect from './PasswordProtect';

import { getRoles, getSelectedRole } from '../../../../utils';

import '../../styles/_sharing-settings.scss';

const SHARE_SETTINGS_ROLES = ['NONE', 'GUEST', 'GUEST_COMMENTER'];

const SEARCH_SETTINGS = [{
  label: 'Disable',
  value: false
}, {
  label: 'Enable',
  value: true
}];



















export default class SharingSettings extends Component


{
  handleRoleChange = _memoize((settingName) => (result) => {
    const { roles, onUpdateShareSetting, shareSettings } = this.props;

    const selectedRole = roles.
    find(({ description }) => description === getStringValueFromGenericInput(result));

    onUpdateShareSetting({
      ...shareSettings,
      [settingName]: {
        ...shareSettings[settingName],
        role: _omit(selectedRole, ['description', '__typename'])
      }
    });
  });

  constructor(props) {
    super(props);

    // Filter roles to only include those suitable for sharing settings
    // If no roles match the expected list, use all available roles as fallback
    let rolesForShareSettings = props.roles.filter(
      (role) => SHARE_SETTINGS_ROLES.includes(role.name)
    );

    // Fallback to all roles if filtered list is empty to support all resource types
    if (rolesForShareSettings.length === 0) {
      rolesForShareSettings = props.roles;
    }

    this.state = {
      passwordEnabled: Boolean(props.shareSettings.publicSettings.password),
      rolesForShareSettings,
      roleOptions: getRoles(rolesForShareSettings)
    };
  }

  setPasswordEnabled = (passwordEnabled) => {
    this.setState({ passwordEnabled });
  };

  handleSwitchChange = () => {
    const { passwordEnabled } = this.state;

    const newValue = !passwordEnabled;

    if (!newValue) {
      this.handlePasswordSave(null);
    }

    this.setPasswordEnabled(newValue);
  };

  handlePasswordSave = (password) => {
    const { onUpdateShareSetting, shareSettings } = this.props;

    onUpdateShareSetting({
      ...shareSettings,
      publicSettings: { ...shareSettings.publicSettings, password }
    });
  };

  handleSearchSettingChange = ({ value }) => {
    const { onUpdateShareSetting, shareSettings } = this.props;

    onUpdateShareSetting({
      ...shareSettings,
      workspaceSettings: { ...shareSettings.workspaceSettings, canSearch: value }
    });
  };

  render() {
    const { shareSettings } = this.props;
    const { passwordEnabled, roleOptions, rolesForShareSettings } = this.state;
    const { publicSettings, workspaceSettings } = shareSettings;

    return (
      <div className="share-settings">
        <div className="share-settings__header">
          <Text heading5 className="share-settings__header__title">
            Select how you want to your project to be accessed
          </Text>
        </div>
        <div className="share-settings__content">
          <SettingSection
            title="Anyone with the link"
            onChange={this.handleRoleChange('publicSettings')}
            defaultValue={getSelectedRole(publicSettings.role, rolesForShareSettings)}
            options={roleOptions}>

            <SettingSection
              title="Password protect"
              subtitle="Set a password to make your link more secure."
              onChange={this.handleSwitchChange}
              defaultValue={passwordEnabled}
              isSwitch>

              {passwordEnabled &&
              <PasswordProtect
                onSave={this.handlePasswordSave}
                value={publicSettings.password} />}


            </SettingSection>
          </SettingSection>
          <SettingSection
            title="Members of this workspace with the link"
            onChange={this.handleRoleChange('workspaceSettings')}
            defaultValue={getSelectedRole(workspaceSettings.role, rolesForShareSettings)}
            options={roleOptions} />

          <SettingSection
            title="Enable workspace search"
            onChange={this.handleSearchSettingChange}
            defaultValue={SEARCH_SETTINGS.find(
              ({ value }) => value === workspaceSettings.canSearch
            )}
            options={SEARCH_SETTINGS} />

        </div>
      </div>);

  }
}